import BaseStore from '../../../../../../components/BaseStore'

export default {
  extends: BaseStore,
  props: {
    taskId: {
      required: true,
      type: String
    },
    data: {
      required: true
    },
    shareData: {
      required: true
    },
    condition: {
      required: true,
      type: Object
    },
    dataTimeFormatter: {
      required: true
    },
    dataTSs: {
      required: true,
      type: Array
    },
    site: {
      required: true,
      type: Object
    }
  },
  computed: {
    formatFactorGroups () {
      const {factorMap, factorGroupMap} = this
      return Object.values(this.condition.factorIds.reduce((map, factorId) => {
        const factor = factorMap[factorId]
        const {parentId} = factor
        let newFactorGroup = map[parentId]

        if (!newFactorGroup) {
          const factorGroup = factorGroupMap[parentId]

          if (!factorGroup) {
            return map
          }

          newFactorGroup = map[parentId] = {
            id: parentId,
            name: factorGroup.name,
            children: []
          }
        }

        newFactorGroup.children.push({
          id: factorId,
          name: factor.name
        })

        return map
      }, {}))
    }
  },
  methods: {
    ready () {},
    getDefaultData () {
      return Promise.resolve(new Error(`Must implements the 'getDefaultData' method`))
    },
    init (shareData) {
      if (!shareData) {
        return
      }

      const {data} = this

      if (data) {
        setTimeout(() => {
          this.ready()
        }, 0)
      } else {
        this.getDefaultData().then(defaultData => {
          this.$emit('update:data', defaultData)
          return Promise.resolve()
        }).then(this.ready).catch(console.error)
      }
    }
  },
  watch: {
    shareData (shareData) {
      this.init(shareData)
    }
  },
  created () {
    this.init(this.shareData)
  }
}



// WEBPACK FOOTER //
// ./src/views/04Statistical-Analysis/11PMF-Analysis/01PM/01Run/preAnalysisComponents/BasePreAnalysis.js